import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails: (_state, action) => ({ ...action.payload }),
    updateUserDetails: (state, action) => ({ ...state, ...action.payload }),
    resetUserDetails: () => initialState,
  },
});

export const { setUserDetails, updateUserDetails, resetUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
